import { createAction, props } from '@ngrx/store';
import {
  GetSessionRedirectStateV1Response,
  StripeCheckoutSessionSummaryV1Response,
} from '@arc/unified-payments-frontend/shared-payment';
import { HttpErrorResponse } from '@angular/common/http';

export const PoiStripeResultIntlSessionActions = {
  loadSessionRedirectStateSuccess: createAction(
    '[POI Intl Stripe Result Session] Load Session Redirect State Success',
    props<{ payload: GetSessionRedirectStateV1Response }>(),
  ),
  loadSessionRedirectStateError: createAction(
    '[POI Intl Stripe Result Session] Load Session Redirect State Error',
    props<{ error: HttpErrorResponse }>(),
  ),

  loadStripeSessionSummarySuccess: createAction(
    '[POI Intl Stripe Result] Load Stripe Session Summary Success',
    props<{ payload: StripeCheckoutSessionSummaryV1Response }>(),
  ),
  loadStripeSessionSummaryError: createAction(
    '[POI Intl Stripe Result] Load Stripe Session Summary Error',
    props<{ error: HttpErrorResponse }>(),
  ),
};
